import React from 'react'
import { EnlaceBase, useDiseñoConfig } from './ComponenteBase'

const DiseñoCompact = ({ 
  enlaces = [], 
  estilosMiniatura = false, 
  esPreview = false,
  configuracion = {}
}) => {
  // Obtener configuración del diseño
  const config = useDiseñoConfig('compact', configuracion)

  // Ajustar para estilos miniatura
  if (estilosMiniatura) {
    return (
      <div className="space-y-0">
        {enlaces.map((enlace, index) => (
          <EnlaceBase
            key={enlace.id || index}
            enlace={enlace}
            estilosMiniatura={estilosMiniatura}
            esPreview={esPreview}
            configuracion={{
              ...config,
              // Ajustes específicos para miniatura
              tamañoIcono: 'pequeño',
              tema: 'compact'
            }}
            className="enlace-miniatura"
          />
        ))}
      </div>
    )
  }

  // Diseño normal para desktop
  return (
    <div className="space-y-1">
      {enlaces.map((enlace, index) => (
        <EnlaceBase
          key={enlace.id || index}
          enlace={enlace}
          estilosMiniatura={estilosMiniatura}
          esPreview={esPreview}
          configuracion={config}
          className="group"
        />
      ))}
    </div>
  )
}

export default DiseñoCompact 